<template>
  <!-- 提成申诉审核 -->
  <div class="shensu-info" v-loading="loading">
      <div class="head-title">变更提成信息</div>
          <div class="form-row-2">
            <div class="form-row">
              <div class="lable">系统判断提成类型为：</div>
              <div class="text danger">{{detail.oldBonusTypeLabel}}</div>
            </div>
            <div class="form-row">
              <div class="lable">客服申请修改为：</div>
              <div class="text danger">{{detail.bonusTypeLabel}}</div>
            </div>
          </div>
          <div class="shensu-content">
            <div class="form-row">
              <div class="lable">图片证据：</div>
              <div class="img-list">
                <div class="img" v-for="(url, index) of detail.urls" :key="index">
                  <el-image class="image" :src="url" fit="contain"></el-image>
                  <div class="look">查看</div>
                  <el-image class="image image-click" :src="url" fit="contain" :preview-src-list="detail.urls"></el-image>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="lable">申诉备注：</div>
              <div class="text ">{{detail.reason}}</div>
            </div>
          </div>
          
          <!-- <div class="form-row">
            <div class="lable">提交审核人：</div>
            <div class="text ">{{detail.applyName}}</div>
          </div>
          <div class="form-row">
            <div class="lable">提交时间：</div>
            <div class="text ">{{detail.applyTime}}</div>
          </div> -->
          <div class="head-title">是否审核通过</div>
          <div class="form-row">
            <el-radio-group v-model="examine.auditStatus">
              <el-radio label="2">通过</el-radio>
              <el-radio label="3">不通过</el-radio>
            </el-radio-group>
          </div>
          <div v-if="examine.auditStatus === '3'">
          <el-form label-width="40px" class="audit_textarea">
            <el-form-item label="原因">
              <el-input placeholder="请输入原因" maxlength="200" show-word-limit type="textarea"
                v-model="examine.auditRemarks"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="examine.auditStatus === '2'">
          <el-form label-width="40px" class="audit_textarea">
            <el-form-item label="备注">
              <el-input placeholder="请输入备注" maxlength="200" show-word-limit type="textarea"
                v-model="examine.auditRemarks"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="button-con">
          <el-button class="btn-cancel" @click="$emit('dialogVisible')">取 消</el-button>
          <el-button class="btn-ok" type="primary" @click="auditApply">确定</el-button>
        </div>
  </div>
</template>

<script>

export default {
  name: 'check-shensu',
  data () {
    return {
      loading: false,
      detail: {},
      examine: { // 是否通过审核
        auditStatus: '2', // 审批结果(2通过；3驳回)
        auditRemarks: ''
      }
    }
  },
  computed: {
    // 申诉修改的类型
    newResult () {
      if (this.orderObj.bonusType === 1) {
        return { label: '复购', value: 2 }
      } else {
        return { label: '首购', value: 1 }
      }
    }
  },
  props: {
    orderObj: { // 订单
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean
    }
  },
  watch: {
    orderObj (val, oldVal) {
      const id = val.orderBonusResponse && val.orderBonusResponse.id || val.applyId
      console.log(val)
      this.$forceUpdate()
      this.getDetail(id) // 查询审批结果
    },
    visible: {
      handler (newVal) {
        // 当弹窗显示时重置表单
        this.examine.auditStatus = '2'
        this.examine.auditRemarks = ''
      },
      immediate: true
    }
  },
  created () { },
  mounted () {
    this.$nextTick(() => {
      console.log(this.orderObj)
      const id = this.orderObj.orderBonusResponse && this.orderObj.orderBonusResponse.id || this.orderObj.applyId
      this.getDetail(id)
      this.$forceUpdate()
    })
  },
  methods: {
    // 获取详情
    getDetail (id) {
      this.loading = true
      this.$api.bonusApplyDetail(id).then((res) => {
        if (res.code === 0) {
          const detail = res.data
          // 字符串转数组
          if (detail.fileUrls) {
            detail.urls = detail.fileUrls.split(',')
          }
          this.detail = detail
        }
        this.loading = false
      }).catch((err) => {
        this.detail = {}
        console.log(err)
        this.loading = false
      })
    },
    // 审核申诉
    auditApply () {
      this.loading = true
      const postData = {
        id: this.orderObj.applyId,
        auditStatus: this.examine.auditStatus,
        auditRemarks: this.examine.auditRemarks
      }
      console.log('>>>', postData)
      this.$api.orderBonusAudit(postData).then((res) => {
        if (res.code === 0) {
          this.$message.success('审核成功')
          this.$emit('submitState')
        }
        this.loading = false
      }).catch((err) => {
        console.log(err)
        this.$emit('closeDialog')
        this.loading = false
      })
    },
  }
}
</script>

